import React, { useState, useEffect , useCallback} from 'react';
import TracksDropdown from 'components/dropdowns/TracksDropdown.js';

export default function ChokesAndMatches(props) {
    let [chokedTrack, setChokedTrack] = useState(undefined);
    let [transposeMatchedTrack, setTransposeMatchedTrack] = useState(undefined);

    useEffect(() => {
        setChokedTrack(props.track.chokes.choke);
        setTransposeMatchedTrack(props.track.chokes.transposeMatch);
    }, [props.track]);

    const onSelectChoke = useCallback((track) => {
        if (track === null) {
            track = undefined;
        }
        props.track.chokes.choke = track;
        setChokedTrack(track);
    }, [props.track]);

    return (
        <div className="chokes-and-matches">
          <div className="choke">
            <div className="choke-label">
              Choke:
            </div>
            <TracksDropdown
              track={chokedTrack}
              trackToSkip={props.track}
              sequencerEngine={props.sequencerEngine}
              onSelectTrack={onSelectChoke}
              />
          </div>
          <div className="transpose-match">
          </div>
        </div>
    );
}
